import type {KeysMatching} from "#base-layer/types/KeysMatching";

/**
 * Resolves the value of the first defined and non-empty property that is a string from a given set of keys in an object.
 * @param source The source object to search through.
 * @param keys An array of keys to check in the source object, in order of priority.
 * @returns The value of the first defined, string, non-empty property found, or null if no suitable property is found.
 */
export function resolvePropertyStackString<
  R extends Record<string, any>,
>(source: R, keys: KeysMatching<R, string>[]) {
  for (const key of keys) {
    const value = source[key];
    if (value !== undefined && value !== null) { // Check for non-null and non-undefined
      if (typeof value === 'string' && value.trim() === '') continue; // Skip empty strings
      // Return the first non-null, non-undefined, non-empty value found
      return String(value);
    }
  }
  // Return null if no suitable property is found
  return null;
}
